import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './themeSlice';
import favoritesReducer from './RDXFav';
import cartReducer from './RDXCart';
import userReducer from './userSlice';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        cart: cartReducer,
        favorites: favoritesReducer,
        user: userReducer,
    },
});
